<template lang="pug">
.row.payment-warning(:class="paymentStatus.class", 
                     v-if="paymentStatus.class !== 'hidden'")
    .col-md-12
        router-link(:to="{name: 'TariffPlan'}")
            h3 
                span(v-html="paymentStatus.text")
    
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'PaymentWarning',
    computed: {
        ...mapGetters(['payedToDisplay']),
        ...mapState({
            recurrent: state => state.payments.recurrent,
            isExpired: state => state.payments.isExpired,
            isExpiringToday: state => state.payments.isExpiringToday
        }),
        paymentStatus() {
            if (this.isExpired) {
                return {
                    class: 'danger',
                    text: `Тариф закончился <b>${this.payedToDisplay}</b>.`
                };
            } else if (!this.recurrent && this.isExpiringToday) {
                return {
                    class: 'warning',
                    text: `Тариф заканчивается уже <b>сегодня</b>.`
                };
            }
            return {
                class: 'hidden'
            };
        }
    }
};
</script>

<style>
.payment-warning {
    padding: 25px 15px 15px 15px;
}
.payment-warning.danger {
    background-color: #d43f3a;
}
.payment-warning.warning {
    background-color: #eea236;
}
.payment-warning h3 {
    color: white!important;
}
</style>


// WEBPACK FOOTER //
// src/components/payments/PaymentWarning.vue